import React from 'react';
import { Card } from 'react-bootstrap';
import MetricHelpIcon from '../dashboard/MetricHelpIcon';

const TeamPanelHeader = ({ title, subtitle, icon, helpText, children }) => (
  <Card.Header className="team-panel-header">
    <div className="team-panel-header__main">
      {icon ? (
        <span className={`team-panel-header__icon bg-${icon.color || 'primary'}-subtle text-${icon.color || 'primary'}`}>
          <i className={icon.className} aria-hidden="true" />
        </span>
      ) : null}
      <div>
        <div className="team-panel-header__title d-inline-flex align-items-center gap-1">
          {title}
          {helpText ? <MetricHelpIcon text={helpText} id={`panel-${title}`} /> : null}
        </div>
        {subtitle ? <small className="team-panel-header__subtitle">{subtitle}</small> : null}
      </div>
    </div>
    {children ? <div className="team-panel-header__actions">{children}</div> : null}
  </Card.Header>
);

export default TeamPanelHeader;
